const stepsImageSlider = new Swiper('.steps-image-slider', {
  slidesPerView: 1,
  loop: true,
  spaceBetween: 20
});

const stepsContentSlider = new Swiper('.steps-content-slider', {
  slidesPerView: 1,
  loop: true,
  spaceBetween: 20,
  effect: 'fade',
  fadeEffect: {
    crossFade: true
  },
  navigation: {
    prevEl: '.steps-slider-prev',
    nextEl: '.steps-slider-next',
  }
});

stepsContentSlider.on('slideChange', slider => {
  let idx = slider.realIndex;

  document.querySelector('.steps-button.bg-charcoal').classList.remove('bg-charcoal', 'text-white');
  document.querySelector(`.steps-button[data-idx="${idx}"]`).classList.add('bg-charcoal', 'text-white');

  stepsImageSlider.slideToLoop(idx);
});

const stepsButtons = document.querySelectorAll('.steps-button');
stepsButtons.forEach(button => {
  button.addEventListener('click', event => {
    const idx = event.currentTarget.dataset.idx;

    document.querySelector('.steps-button.bg-charcoal').classList.remove('bg-charcoal', 'text-white');
    event.currentTarget.classList.add('bg-charcoal', 'text-white');

    stepsContentSlider.slideToLoop(idx);
  });
});